@if (workspace.modalOpen()) {
  <dialog
    class="fixed inset-0 z-[120] flex h-screen w-screen max-h-none max-w-none items-center justify-center border-0 bg-black/40 p-4 !mt-0"
    [open]="workspace.modalOpen()"
    aria-labelledby="builderWorkspacePickerTitle"
    (keydown.escape)="workspace.cancelModal()"
    (cancel)="onDialogCancel($event)"
  >
    <div
      class="w-full max-w-lg rounded-2xl bg-white shadow-2xl dark:bg-[#0e1726]"
      (click)="$event.stopPropagation()"
      (keydown)="$event.stopPropagation()"
    >
      <div class="flex items-start justify-between gap-4 border-b border-[#ececf0] px-6 py-4 dark:border-white/10">
        <div>
          <h2 id="builderWorkspacePickerTitle" class="text-lg font-semibold text-[#102030] dark:text-white">
            Which builder do you want to connect?
          </h2>
          <p class="mt-1 text-sm text-[#696b72] dark:text-gray-400">
            Choose a builder to view Property Bookings for that workspace.
          </p>
        </div>
        <button
          type="button"
          class="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-gray-100 text-gray-900 hover:bg-gray-200 dark:bg-gray-800 dark:text-white"
          aria-label="Close"
          (click)="workspace.cancelModal()"
        >
          ✕
        </button>
      </div>

      @if (workspace.modalError()) {
        <p class="mx-6 mt-4 text-sm text-red-600 dark:text-red-400" role="alert">
          {{ workspace.modalError() }}
        </p>
      }

      <ul class="grid gap-3 p-6">
        @for (builder of workspace.builders(); track builder.workspaceId) {
          <li>
            <button
              type="button"
              class="flex w-full items-center justify-between rounded-xl border border-[#ececf0] bg-[#f9fafb] px-4 py-4 text-left transition hover:border-primary hover:bg-primary/5 disabled:opacity-60 dark:border-white/10 dark:bg-[#121d32] dark:hover:border-primary"
              [disabled]="workspace.connectingWorkspaceId() !== null"
              (click)="workspace.connectBuilderFromModal(builder.workspaceId)"
            >
              <span class="text-base font-semibold text-[#1d1d1f] dark:text-white">
                {{ builder.workspaceName }}
              </span>
              @if (workspace.connectingWorkspaceId() === builder.workspaceId) {
                <span class="text-sm text-[#696b72]">Connecting…</span>
              } @else {
                <span class="text-sm font-medium text-primary">Connect</span>
              }
            </button>
          </li>
        }
      </ul>
    </div>
  </dialog>
}
